import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import cardActions from '../../../actions/savedCards';
import {IMAGES_PATHS} from '../../../consts';
import {
    getAvailableLanguageCodes,
    getCountryCode,
    getCsrf,
    getLanguageCode,
    getTranslations,
    getWebRelaunchStyleEnabled
} from '../../../utils/selectors';
import {pushAnalyticsEvent} from '../../organisms/Analytics';
import CreditCard from '../../organisms/CreditCard';
import {getSubmittingStatus} from '../CyberSource/cybersource.selectors';

export class CybersourceCardSelection extends Component {
    createTransaction = (card, cvv) => {
        const {
            csrfToken,
            languageCode,
            availableLanguageCodes,
            actions
        } = this.props;
        const shouldUseSavedCard = true;
        const {registrationId} = card;

        actions.startAuthorizationSavedCard(
            csrfToken,
            languageCode,
            availableLanguageCodes,
            shouldUseSavedCard,
            registrationId,
            cvv
        );
    }

    removeCard = card => {
        const {
            languageCode,
            actions,
            csrfToken,
            paymentSessionId
        } = this.props;
        const {registrationId} = card;

        actions.removeCreditCard(
            csrfToken,
            {
                registrationId,
                languageCode,
                paymentSessionId
            }
        );

        pushAnalyticsEvent({
            interactionName: 'card payment interaction',
            cardPaymentAction: 'remove saved card'
        });
    }

    render() {
        const {
            isWebRelaunchStyleEnabled,
            translations,
            setCybersourceVisibility,
            creditcards,
            isSubmitting,
            genericError
        } = this.props;

        const addCreditCardImgSrc = isWebRelaunchStyleEnabled ?
            IMAGES_PATHS.CREDIT_CARD_ADD_RELAUNCH :
            IMAGES_PATHS.CREDIT_CARD_ADD;

        return (
            <section className="card-selection-container">
                <div className="centered-container" id="credit-cards-container">
                    <h1>{translations.creditCard.heading}</h1>
                    <div className="call-to-action-box card-selection-cta-box">
                        <button
                            id="add-new-card"
                            type="button"
                            className="show-cybersource"
                            disabled={genericError}
                            onClick={() => setCybersourceVisibility(true)}
                        >
                            <div className="heading-with-icon">
                                <img
                                    className="heading-with-icon-img"
                                    src={addCreditCardImgSrc}
                                    alt="add"
                                />
                                <h2>
                                    {translations.creditCard.add}
                                </h2>
                            </div>
                        </button>
                    </div>

                    <h4 className="option-credit">
                        {translations.creditCard.chooseExisting}
                    </h4>

                    <ul className="credit-cards-list" id="credit-cards-list">
                        {creditcards.map(creditCard => (
                            <CreditCard
                                key={creditCard.cardId.value}
                                card={creditCard}
                                genericError={genericError}
                                isSubmitting={isSubmitting}
                                translations={translations}
                                onSubmit={this.createTransaction}
                                onRemove={this.removeCard}
                            />
                        ))}
                    </ul>
                </div>
            </section>
        );
    }
}

CybersourceCardSelection.propTypes = {
    languageCode: PropTypes.string.isRequired,
    csrfToken: PropTypes.string.isRequired,
    translations: PropTypes.shape({
        common: PropTypes.shape({
            continue: PropTypes.string.isRequired,
            cancel: PropTypes.string.isRequired
        }),
        creditCard: PropTypes.shape({
            chooseExisting: PropTypes.string.isRequired,
            expires: PropTypes.string.isRequired,
            confirmRemove: PropTypes.string.isRequired,
            labelRemove: PropTypes.string.isRequired,
            popUp: PropTypes.shape({
                heading: PropTypes.string.isRequired,
                warningText: PropTypes.string.isRequired,
                cvv: PropTypes.string.isRequired
            })
        }),
        cybersource: PropTypes.shape({
            errors: PropTypes.shape({
                securityCode: PropTypes.shape({
                    required: PropTypes.string.isRequired,
                    invalid: PropTypes.string.isRequired
                })
            })
        })
    }).isRequired,
    creditcards: PropTypes.arrayOf(PropTypes.shape({
        registrationId: PropTypes.string.isRequired,
        cardId: PropTypes.shape({
            value: PropTypes.string.isRequired
        }).isRequired,
        displayData: PropTypes.shape({
            expirationDate: PropTypes.string.isRequired,
            maskedCardNumber: PropTypes.string.isRequired,
            cardType: PropTypes.string.isRequired
        }).isRequired
    })).isRequired,
    actions: PropTypes.shape({
        startAuthorizationSavedCard: PropTypes.func.isRequired,
        removeCreditCard: PropTypes.func.isRequired
    }).isRequired,
    availableLanguageCodes: PropTypes.arrayOf(PropTypes.string).isRequired,
    isWebRelaunchStyleEnabled: PropTypes.bool.isRequired,
    isSubmitting: PropTypes.bool.isRequired,
    paymentSessionId: PropTypes.string.isRequired,
    genericError: PropTypes.bool.isRequired
};

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({...cardActions}, dispatch)
});

const mapStateToProps = state => ({
    creditcards: state.cardSelection.creditcards,
    countryCode: getCountryCode(state),
    translations: getTranslations(state),
    csrfToken: getCsrf(state),
    languageCode: getLanguageCode(state),
    isSubmitting: getSubmittingStatus(state),
    isWebRelaunchStyleEnabled: getWebRelaunchStyleEnabled(state),
    availableLanguageCodes: getAvailableLanguageCodes(state)
});

export const ConnectedCybersourceCardSelection = connect(mapStateToProps, mapDispatchToProps)(CybersourceCardSelection);

export default ConnectedCybersourceCardSelection;
